import { EventEmitter, Output } from '@angular/core';
import { IController, IScope, ITimeoutService, IWindowService } from 'angular';
import { IState } from 'angular-ui-router';
import { set } from 'lodash';
import { ImSchool } from 'Src/ng2/shared/services/im-models/im-school';
import { IStudent } from '../../../../../ng2/shared/typings/interfaces/student.interface';
export class StudentRegentsPanelCtrl implements IController {
  static $inject = ['$scope', '$state', '$window', '$timeout', 'Student', 'ImSchool'];

  // bindings
  private school;
  @Output() saveStudent = new EventEmitter();

  // local
  private title;
  private examsWithNoPlan;
  private schedExamsNotInStars;
  private schedExamsWithNoSupport;
  private hideSchedInStars;
  private summaryItems;

  constructor(
    private $scope: IScope,
    private $state: IState,
    private $window: IWindowService,
    private $timeout: ITimeoutService,
    private Student: IStudent,
    private ImSchool: ImSchool,
  ) {
    this.title = 'Regents';
    this.examsWithNoPlan = { count: 0 };
    this.schedExamsNotInStars = { count: 0 };
    this.schedExamsWithNoSupport = { count: 0 };
  }

  $onInit() {
    this.hideSchedInStars = this.ImSchool.isCharterSchool(this.school);

    this.$scope.$watch(
      () => {
        return this.examsWithNoPlan.count;
      },
      () => {
        this.updateFlags();
      },
    );

    this.$scope.$watch(
      () => {
        return this.schedExamsWithNoSupport.count;
      },
      () => {
        this.updateFlags();
      },
    );

    if (!this.hideSchedInStars) {
      this.$scope.$watch(
        () => {
          return this.schedExamsNotInStars.count;
        },
        () => {
          this.updateFlags();
        },
      );
    }
  }

  // methods
  goToMasterTable = function() {
    this.$window.open(this.$state.href('main.school.settings.master-program'), '_blank');
  };

  updateFlags = () => {
    const examsWithNoPlanCount = this.examsWithNoPlan.count;
    const schedExamsNotInStarsCount = this.schedExamsNotInStars.count;
    const schedExamsWithNoSupportCount = this.schedExamsWithNoSupport.count;
    this.summaryItems = [];

    if (examsWithNoPlanCount) {
      const plural = examsWithNoPlanCount > 1;

      this.summaryItems.push({
        icon: 'flag',
        text: `${examsWithNoPlanCount} NEEDED ${plural ? 'EXAMS' : 'EXAM'} WITH NO PLAN`,
      });
    }

    if (!this.hideSchedInStars && schedExamsNotInStarsCount) {
      const plural = schedExamsNotInStarsCount > 1;

      this.summaryItems.push({
        icon: 'flag',
        text: `${schedExamsNotInStarsCount} ${plural ? 'PLANNED EXAMS' : 'PLANNED EXAM'} NOT IN STARS`,
      });
    }

    if (schedExamsWithNoSupportCount) {
      const plural = schedExamsWithNoSupportCount > 1;

      this.summaryItems.push({
        icon: 'flag',
        text: `${schedExamsWithNoSupportCount} ${plural ? 'PLANNED EXAMS' : 'PLANNED EXAM'} WITH NO SUPPORT`,
      });
    }
  };

  handleSave = function(data, fieldPath) {
    let patch;
    if (typeof data === 'object') patch = data;
    else if (data === '') patch = set({}, fieldPath, null);
    else patch = set({}, fieldPath, data);
    this.saveStudent.emit({ patch, path: fieldPath });
  };
}
angular.module('nv.singleStudent').controller('StudentRegentsPanelCtrl', StudentRegentsPanelCtrl);
